export default {
  about: 'About',
  help: 'Help',
  contact: 'Contact',
  highpay: 'Job',
  agreement: 'Service',
  payment: 'Payment',
  cooperation: 'Cooperation',
  ICP_recordNum: 'ICP: Zhe ICP 18015679',
  networkSecurity: 'Zhejiang public network Record 33011002013432',

  us_collaborate: 'Cooperate',
  customer: 'Contact',
  booth_consult: 'Booth',
  viewer_consult: 'Audience',
  work_time: 'Monday to Sunday',
  work_time2: 'Monday to Friday',
  friendship_link: 'Friendly link',

  WeChatofficial: 'Public account',
  WeChat_applet: 'Mini program',
  desc: 'Please use mobile phone wechat scan code to follow',
  scan_follow: 'Scan the code to pay attention to the public number',
  scan_openApplet: 'Scan code to open the small program'
}
